import React from 'react';

import {Create} from 'react-admin';

import RubricForm from "./RubricForm";

const RubricCreate = (props) => (
    <Create {...props}><RubricForm/></Create>
);

export default RubricCreate;
